module.exports = __webpack_public_path__ + "img/015c42b11d93e657171ebea3fe498c6a.png";